import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";

export default function MarkdownContent({ content, components, map, ...args }) {
	const markdownComponents = components || map;
	return (
		<ReactMarkdown
			components={markdownComponents}
			{...args}
		>
			{content}
		</ReactMarkdown>
	);
}

MarkdownContent.propTypes = {
	content: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string))
	]),
	components: PropTypes.objectOf(PropTypes.elementType),
	map: PropTypes.objectOf(PropTypes.elementType)
};
